import LayoutPage from "../../Components/LayoutPage"
import Buttons from "./Components/Buttons"
import BlogsList from "./Components/BlogsList"

export default function Blogs() {
  return (
    <LayoutPage activeIndex={13} navItems={["مدیریت بلاگ"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto">
      <Buttons/>
      <BlogsList/>
    </LayoutPage>
  )
}